import React, { useState, useEffect } from "react";
import Button from "../../../../../ui-styles/controls/button";
import Loader from "../../../../../lib/ui/loader/Loader";
// import NoData from "../../../../../lib/ui/nodata/NoData";
import NoDataCertificate from "./NoData";
import { updatedocument } from "../../../../../actions/users";
import DialogPopup from "../../../../common/DialogPopup";

const CertificationsTab = (props) => {
    // const [certifications, setCertifications] = useState({
    //     medicaldocuments: { title: "Medical Certifications", data: [] },
    //     provisionaldocuments: { title: "Provisional Certificates", data: [] },
    // });
    const [loading, setLoading] = useState(false)
    const [actions, setActions] = useState({});
    const [reasons, setReasons] = useState({});
    const [select, setSelected] = useState({})
    const [open, setOpen] = useState(false);
    const acceptedTypes = ["doc", "docx", "pdf", "xls", "xlsx", "ppt", "pptx"];
    const { userData, handleFileView, certifications, setCertifications } = props;

    const handleDialogOpen = (id, documentId) => {
        setSelected({ id: id, documentId: documentId });
        setOpen(true);
    };

    const handleDialogClose = () => {
        setSelected(null);
        setOpen(false);
    };

    const handleAccept = async (id, documentType) => {
        setLoading(true);
        try {
            setLoading(true)
            await updatedocument(userData.userId, { documentId: id, status: "Approved", documentType: documentType });
            setCertifications((prevCertifications) => ({
                ...prevCertifications,
                [documentType]: {
                    ...prevCertifications[documentType],
                    data: prevCertifications[documentType].data.map((cert) =>
                        cert._id === id ? { ...cert, status: "approved" } : cert
                    ),
                },
            }));
            setSelected(null);
            setOpen(false);
        } catch (error) {
            console.error("Error updating document:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleDecline = (id, documentType) => {
        setCertifications((prevCertifications) => ({
            ...prevCertifications,
            [documentType]: {
                ...prevCertifications[documentType],
                data: prevCertifications[documentType].data.map((cert) =>
                    cert._id === id ? { ...cert, status: "declining" } : cert
                ),
            },
        }));
    };

    const handleCancel = (id, documentType) => {
        setCertifications((prevCertifications) => ({
            ...prevCertifications,
            [documentType]: {
                ...prevCertifications[documentType],
                data: prevCertifications[documentType].data.map((cert) =>
                    cert._id === id ? { ...cert, status: "pending" } : cert
                ),
            },
        }));
    };

    const handleReasonChange = (e, certId) => {
        e.persist();
        const { value } = e.target;
        setReasons((prev) => ({
            ...prev,
            [certId]: value,
        }));
    };

    const handleSendDeclineReason = async (id, reason, documentType) => {
        const trimmedReason = (reason || "").trim();
        if (trimmedReason) {
            setLoading(true);
            try {
                await updatedocument(userData.userId, { documentId: id, status: "rejected", comment: trimmedReason, documentType: documentType });

                setCertifications((prevCertifications) => ({
                    ...prevCertifications,
                    [documentType]: {
                        ...prevCertifications[documentType],
                        data: prevCertifications[documentType].data.map((cert) =>
                            cert._id === id ? { ...cert, status: "rejected" } : cert
                        ),
                    },
                }));
            } catch (error) {
                console.error("Error updating document:", error);
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <div style={{ padding: "10px" }}>
            {loading && <Loader />}
            {certifications?.medicaldocuments?.data?.length === 0 && certifications?.provisionaldocuments?.data?.length === 0 ? (
                <NoDataCertificate />
            ) : (
                Object.values(certifications).map((section, sectionIndex) => (
                    <div className="flexCol mrgBtm8 brdrRadius" style={{ border: "1px solid #D4D4D4", padding: "10px" }} key={sectionIndex}>
                        <span style={{ fontSize: "16px", fontWeight: "500", paddingBottom: "12px" }}>{section.title}</span>
                        {section.data.map((cert) => (
                            <div
                                key={cert.id}
                                className="fullHeight fullWidth brdrRadius pdngXS mrgBtm8 "
                                style={{
                                    border: "1px solid #D4D4D4",
                                    backgroundColor: "#fff",
                                }}
                            >
                                <span style={{ fontSize: "16px", fontWeight: "500", paddingBottom: "10px" }}> {cert.title}</span>

                                <div className="flexAutoRow" style={{ display: "flex", flexDirection: "row" }}>
                                    <div style={{ height: "90px", width: "90px", paddingRight: "8px" }}>
                                        <img
                                            src={
                                                cert?.fileType?.startsWith("image")
                                                    ? cert.url
                                                    : acceptedTypes?.includes(cert.key.split(".").pop())
                                                    ? `/images/file-icons/${cert.key ? cert.key.split(".").pop() : "blank"}-file.png`
                                                    : `/images/file-icons/blank-file.png`
                                            }
                                            style={{
                                                ...(cert?.fileType?.startsWith("image")
                                                    ? { height: "100%", width: "100%", objectFit: "contain" }
                                                    : { height: "80%", width: "80%", objectFit: "contain" }),
                                                cursor: "pointer", // Added cursor pointer for hover effect
                                            }}
                                            alt="Certification"
                                            onClick={() => handleFileView(cert)}
                                        />
                                    </div>

                                    {/* <div className="flexMinWidthCol" style={{ paddingRight: "8px" }}>
                                        <span className="smallText ellipsisTxt" style={{ fontWeight: "500" }}>
                                            {cert.council}
                                        </span>
                                        <span className="smallText">License: {cert.license}</span>
                                        <span className="smallText">Expiry Date: {cert.expiry}</span>
                                        <span className="smallText">{cert.country}</span>
                                    </div> */}
                                    <div className="flexMinWidthCol" style={{ paddingRight: "8px" }}>
                                        {section.title === "Medical Certifications" ? (
                                            <>
                                                <span
                                                    className="ellipsisTxt"
                                                    style={{ fontSize: "14px", fontWeight: "500", lineHeight: 1.4 }}
                                                >
                                                    {cert.license}
                                                </span>
                                                <span className="smallText">License No:{cert.licenseNo}</span>
                                                <span className="smallText">
                                                    {" "}
                                                    Issue Date:{" "}
                                                    {new Date(cert.issuedDate).toLocaleDateString("en-US", {
                                                        year: "numeric",
                                                        month: "long",
                                                        day: "numeric",
                                                    })}{" "}
                                                </span>

                                                <span className="smallText">
                                                    Expiry Date:{" "}
                                                    {new Date(cert.expirationDate).toLocaleDateString("en-US", {
                                                        year: "numeric",
                                                        month: "long",
                                                        day: "numeric",
                                                    })}
                                                </span>
                                                <span className="smallText"> {cert.country}</span>
                                                {(() => {
                                                    const expiryDate = new Date(cert.expirationDate);
                                                    const currentDate = new Date();
                                                    const timeDifference = expiryDate - currentDate;
                                                    const remainingDays = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

                                                    if (remainingDays > 0 && remainingDays <= 120) {
                                                        return (
                                                            <span
                                                                className="smallText"
                                                                style={{
                                                                    color: "#F44336",
                                                                    fontWeight: "390",
                                                                }}
                                                            >
                                                                Certificate will expire in {remainingDays} day{remainingDays > 1 ? "s" : ""}
                                                                .
                                                            </span>
                                                        );
                                                    }
                                                    return null;
                                                })()}
                                            </>
                                        ) : (
                                            <>
                                                <span className="smallText ellipsisTxt" style={{ fontWeight: "500" }}>
                                                    {cert.department}
                                                </span>
                                                <span className="smallText">Degree: {cert.degree}</span>
                                                <span className="smallText">Year of Passing: {cert.yearOfPassing}</span>
                                                <span className="smallText">Specialist: {cert.speciality}</span>
                                            </>
                                        )}
                                    </div>
                                </div>
                                <div
                                    className="alignCenter justifyCenter childRight pdngBtm16"
                                    style={{
                                        gap: "16px",
                                        paddingBottom: "10px",
                                    }}
                                >
                                    {cert.status === "pending" && (
                                        <>
                                            <span
                                                className="smallText cursorPointer"
                                                onClick={() =>
                                                    handleDialogOpen(
                                                        cert._id,
                                                        section.title === "Medical Certifications"
                                                            ? "medicaldocuments"
                                                            : "provisionaldocuments"
                                                    )
                                                }
                                                style={{
                                                    fontWeight: "500",
                                                    color: "#4CAF50",
                                                }}
                                            >
                                                Accept
                                            </span>
                                            <span
                                                className="smallText cursorPointer"
                                                onClick={() =>
                                                    handleDecline(
                                                        cert._id,
                                                        section.title === "Medical Certifications"
                                                            ? "medicaldocuments"
                                                            : "provisionaldocuments"
                                                    )
                                                }
                                                style={{
                                                    fontWeight: "500",
                                                    color: "#F44336",
                                                }}
                                            >
                                                Decline
                                            </span>
                                        </>
                                    )}

                                    {cert?.status === "approved" && (
                                        <span
                                            className="smallText"
                                            style={{
                                                fontWeight: "500",
                                                color: "#4CAF50",
                                            }}
                                        >
                                            Accepted
                                        </span>
                                    )}
                                    {cert?.status === "rejected" && (
                                        <span
                                            className="smallText"
                                            style={{
                                                fontWeight: "500",
                                                color: "#F44336",
                                            }}
                                        >
                                            Rejected
                                        </span>
                                    )}
                                </div>
                                {cert?.status === "declining" && (
                                    <>
                                        <textarea
                                            className="textFullWidth"
                                            placeholder="Reason"
                                            value={reasons[cert._id] || ""}
                                            onChange={(e) => handleReasonChange(e, cert._id)}
                                        ></textarea>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                alignItems: "flex-end",
                                                paddingTop: "10px",
                                            }}
                                        >
                                            <Button
                                                onClick={() =>
                                                    handleCancel(
                                                        cert._id,
                                                        section.title === "Medical Certifications"
                                                            ? "medicaldocuments"
                                                            : "provisionaldocuments"
                                                    )
                                                }
                                                text="Cancel"
                                                variant="outlined"
                                                size="sm"
                                            />
                                            <Button
                                                onClick={() =>
                                                    handleSendDeclineReason(
                                                        cert._id,
                                                        reasons[cert._id],
                                                        section.title === "Medical Certifications"
                                                            ? "medicaldocuments"
                                                            : "provisionaldocuments"
                                                    )
                                                }
                                                text="Send"
                                                variant="contained"
                                                size="sm"
                                                style={{ color: "white" }}
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                ))
            )}
            {open && (
                <DialogPopup
                    open={open}
                    onClose={handleDialogClose}
                    onConfirm={handleAccept}
                    selectItem={select}
                    title="Accept Certificate"
                    message={`You're accepting ${userData?.firstName || "the user’s"} Certificate
                   `}
                />
            )}
        </div>
    );
};

export default CertificationsTab;
